import { render } from "./GoalModal.vue?vue&type=template&id=aa3b5808&scoped=true"
import script from "./GoalModal.vue?vue&type=script&lang=js"
export * from "./GoalModal.vue?vue&type=script&lang=js"

import "./GoalModal.vue?vue&type=style&index=0&id=aa3b5808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3b5808"]])

export default __exports__